<template>
  <BaseTable
    :headers="headers"
    :rows="rows"
    :perPage="perPage"
    @page-changed="handlePageChange"
    :totalPages="totalPages"
    :loading="loading"
    :rowIdFn="row => `kiosks.table.row.${row.id}`"
    :cellIdFn="(row, col) => `kiosks.table.cell.${col}.${row.id}`"
  >
    <template #cell-status="{ row }">
      <img
        :src="require(`@/assets/images/${row.status}.png`)"
        style="width: 12px;margin-right: 10px;"
      />
    </template>
    <template #cell-available="{ row }">
      <BaseButton
        size="xs"
        :variant="row.available ? 'success' : 'danger'"
        @click="deactivateKiosk(row)"
        rounded="full"
        :id="`kiosks.table.button.deactivate.${ row.id }`"
      > 
        {{ (row.available ? translate('Not Used') : translate('Used')) }} 
      </BaseButton>
    </template>
    <template #cell-terminal="{row}">
      {{row.ipaddress}} - {{row.terminal}}
    </template>
    <template #cell-lastseen="{row}">
      {{ getLastSeen(row) }}
    </template>
    <template #cell-alarm="{row}">
      <template v-if="!row.alarm">
        <img
          :src="require(`@/assets/images/online.png`)"
          style="width: 12px;margin-right: 10px;"
        />
      </template>
      <template v-else>
        <div class="relative inline-block">
          <BaseButton :id="`kiosks.table.button.alarmdetails.${row.id}`" @click="showAlarmDetails(row)" size="xs" variant="primary">{{ translate('More Details') }}</BaseButton>
          <div
            v-if="showingAlarmDetail.id == row.id"
            class="absolute right-0 mt-2 w-96 bg-white border rounded shadow-lg z-10"
          >
            <div class="px-3 py-2 border-b flex justify-end items-center">
              <BaseButton @click="showingAlarmDetail.id = null" size="xs">×</BaseButton>
            </div>

            <div class="p-2 max-h-48 overflow-auto">
              <table class="min-w-full text-sm text-left text-gray-700">
                <thead class="bg-gray-100 uppercase text-gray-600">
                  <tr>
                    <td class="px-2 py-2 text-xs">{{translate('ALARM INFORMATION')}}</td>
                    <td class="px-2 py-2 text-xs">{{translate('Date & Time')}}</td>
                    <td class="px-2 py-2 text-xs">{{translate('ACTION')}}</td>
                  </tr>
                </thead>
                <tbody>
                  <tr class="border-t">
                    <td class="px-2 py-3">{{ showingAlarmDetail.data.reason }}</td>
                    <td class="px-2 py-3">{{ formatDate(showingAlarmDetail.data.created_at) }}</td>
                    <td class="px-2 py-3">
                      <BaseButton :id="`kiosks.table.button.resetalrm.${ row.id }`" @click="resetAlarm(row)" size="xs">{{translate('CLEAR')}}</BaseButton>
                    </td>
                  </tr>
                  <tr v-if="!showingAlarmDetail.data">
                    <td colspan="3" class="text-center py-4 text-gray-500">{{ translate('No Data') }}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </template>
    </template>
    <template #cell-action="{ row }">
      <div class="flex gap-2 overflow-visible relative">
        <BaseButton
          size="lg"
          rounded
          :id="`kiosks.table.button.edit.${row.id}`"
          @click="handleEdit(row)"
          variant="primary"
          :tooltip="translate('Edit')"
        >
          <i class="far fa-edit"></i>
        </BaseButton>
        <BaseButton
          size="lg"
          rounded
          :id="`kiosks.table.button.sync.${row.id}`"
          v-if="row.is_enrolled" 
          @click="handleRefresh(row)"
          variant="primary"
          :tooltip="translate('Sync')"
        >
          <i class="fas fa-sync-alt"></i>
        </BaseButton>
        <BaseButton
          size="lg"
          rounded
          variant="primary"
          :id="`kiosks.table.button.view.${ row.id }`" 
          @click="handleView(row)"
          :tooltip="translate('View')"
        >
          <i class="fas fa-eye"></i>
        </BaseButton>
      </div>
    </template>
  </BaseTable>
</template>
<script>
import BaseTable from '@/components/V2/BaseTable.vue';
import { translations } from '@/mixins';
import moment from 'moment';
import BaseButton from '@/components/V2/BaseButton.vue';

export default {
  name: 'KiosksItemsTable',
  components: {
    BaseTable,
    BaseButton
  },
  mixins: [translations],
  props: {
    headers: {
      type: Array,
      required: true
    },
    rows: {
      type: Array,
      required: true
    },
    perPage: {
      type: Number,
      default: 5
    },
    totalPages: {
      type: Number,
      default: 1
    },
    loading: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      showingAlarmDetail: {
        id: null,
        details: null
      }
    }
  },
  methods: {
    handlePageChange(page) {
      this.$emit('page-changed', page);
    },
    handleEdit(data) {
      this.$emit('edit', data);
    },
    handleView(data) {
      this.$emit('view', data);
    },
    handleRefresh(data) {
      this.$emit('refresh-mdm', data);
    },
    resetAlarm(data) {
      this.$emit('reset-alarm', data);
    },
    deactivateKiosk(data) {
      this.$emit('deactivate-kiosk', data);
    },
    getLastSeen(data) {
      if (!data.lastseen) {
        return this.translate('Never');
      }

      return moment.utc(data.lastseen, "YYYY-MM-D hh:mm:ss").locale("en-us").fromNow();
    },
    showAlarmDetails(data) {
      this.showingAlarmDetail.id = data.id;
      this.showingAlarmDetail.data = { ...data.alarm, created_at: data.created_at };
    },
    formatDate(date) {
      return moment
        .utc(date, "YYYY-MM-D hh:mm:ss")
        .locale("en-us")
        .local()
        .format("MMM D YYYY HH:mm");
    },
    closeDetailsPopup() {
      this.showingAlarmDetail = {
        id: null,
        details: null
      };
    }
  }
}
</script>